export const speechSupported = () => typeof window !== "undefined" && "speechSynthesis" in window;

export const listVoices = () =>
  new Promise((resolve) => {
    if (!speechSupported()) return resolve([]);
    const voices = window.speechSynthesis.getVoices();
    if (voices.length) return resolve(voices);
    window.speechSynthesis.onvoiceschanged = () => resolve(window.speechSynthesis.getVoices());
    setTimeout(() => resolve(window.speechSynthesis.getVoices()), 1500);
  });

export function speak(text, { voice, rate = 1, pitch = 1, lang = "it", onEnd } = {}) {
  if (!speechSupported() || !text) return;
  const u = new SpeechSynthesisUtterance(text);
  const match = window.speechSynthesis.getVoices().find((v) => v.name === voice);
  if (match) u.voice = match;
  u.lang = match?.lang || (lang === "it" ? "it-IT" : "en-US");
  u.rate = rate;
  u.pitch = pitch;
  if (onEnd) u.onend = onEnd;
  window.speechSynthesis.speak(u);
}

export const stopSpeaking = () => speechSupported() && window.speechSynthesis.cancel();
